export enum CabinSearchParams {
  cabinNumber = 'cabinNumber',
}
